var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"EditProducerData"}},[_c('EditProducer',{attrs:{"data":_vm.is_admin_dealer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }